import { render, staticRenderFns } from "./ZvTable.vue?vue&type=template&id=69fd877c&scoped=true&"
import script from "./ZvTable.vue?vue&type=script&lang=js&"
export * from "./ZvTable.vue?vue&type=script&lang=js&"
import style0 from "./ZvTable.vue?vue&type=style&index=0&id=69fd877c&prod&lang=sass&scoped=true&"
import style1 from "./ZvTable.vue?vue&type=style&index=1&id=69fd877c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fd877c",
  null
  
)

export default component.exports